var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 40H50.0001M30.0001 53.3333H50.0001M56.6667 70H23.3334C21.5653 70 19.8696 69.2976 18.6194 68.0474C17.3691 66.7971 16.6667 65.1014 16.6667 63.3333V16.6667C16.6667 14.8986 17.3691 13.2029 18.6194 11.9526C19.8696 10.7024 21.5653 10 23.3334 10H41.9534C42.8374 10.0002 43.6851 10.3515 44.3101 10.9767L62.3567 29.0233C62.9819 29.6483 63.3332 30.496 63.3334 31.38V63.3333C63.3334 65.1014 62.631 66.7971 61.3808 68.0474C60.1305 69.2976 58.4349 70 56.6667 70Z",
    stroke: "#D1D5DB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.1c4666695531cfba93a0c3fdbc6940b1.svg";
export { ForwardRef as ReactComponent };